import atcError from "../../trading-room/js/atcerror";

/**
 * Class to handle video tagging for the admin.
 *
 * This is a standalone class that manages it's self. Should only be loaded on a "play a video" page.
 */
class VideoTagManager
{
    /**
     * Gets our video ID from the DOM
     *
     * @returns {number}
     */
    static getVideoIdFromDOM()
    {
        return parseInt($('#VideoCaller').attr('data-id'));
    }

    /**
     * Construct our class.
     *
     * @param {Number} videoId
     */
    constructor(videoId)
    {

        // let the DOM tell us if we're an admin or not.
        this.isAdmin = $('#frmAddVideoTag').attr('data-is-admin') === 'true';

        if (videoId) {
            this.videoId = videoId;
            // this.allocCurrentVideo(this.videoId);
        } else {
            $('.btn-video-addTag, .divAddVideoTagForm').remove();
            this.videoId = 0;
            // this.currentVideo = null;
        }

        /* NOTE: Not sure why this was a thing?
        if ($.fn.spinner) {
            $('#start_seconds').spinner();
        }
        */

        this.addListeners();
        if (this.isModeratorUser()) {
            this.addAdminListeners();
        }

        const hashTime = VideoTagManager.getHashTime(window.location.hash);
        if (hashTime) {
            this.gotoVideoTime(hashTime, false);
        }

    }

    /**
     * Alert a message.
     *
     * @param {String} what
     */
    alert(what)
    {
        let $errorDlg = $('#atc-ErrorDialog').clone();
        if (!$errorDlg.length) {
            alert(what);
        } else {
            $errorDlg.attr('id', 'VideoManagerWarning');
            $('.modal-header', $errorDlg).attr('class', 'alert-warning modal-header');
            $('.modal-title', $errorDlg).html("Warning");
            $('.modal-body', $errorDlg).html(what);
            $errorDlg.insertBefore('#atc-ErrorDialog');
            $errorDlg.modal('show').on('hidden.bs.modal', function () {
                // allow other things to work with this before we destroy it.
                setTimeout(() => {
                    $errorDlg.modal('dispose').remove();
                }, 1);
            });
        }

    }

    /**
     *
     * @returns {boolean}
     */
    showAddForm()
    {
        this.pauseVideo();
        const vid = document.getElementById('VideoCaller');
        if (vid.currentTime <= 1) {
            alert('Please tag a point later than 1 second into the video. ');
            return false;
        }

        $('#tagId').val('');
        $('#start_seconds').val(Math.floor(vid.currentTime));
        $('#end_seconds').val(vid.duration);
        $('.divAddVideoTagForm').show();
        $('.btn-video-addTag').hide();
        $('#tags').val('').focus();

        return true;
    }

    /**
     * Pause the video if it's playing.
     */
    pauseVideo()
    {
        const video = document.getElementById('VideoCaller');
        const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
        if (video && isVideoPlaying(video)) {
            video.pause();
        }
    }

    /**
     * Display the edit tag form.
     *
     * @param {Number} tagId
     * @param {Number} startSeconds
     *
     * @returns {boolean}
     */
    editTag(tagId, startSeconds)
    {
        if (! this.isModeratorUser()) {
            return false;
        }

        return this.displayAddEditTag(tagId, startSeconds);
    }
    /**
     * The form to display the edit/new tag.
     *
     * @param {Number} tagId
     * @param {Number} startSeconds
     * @returns {boolean}
     */
    displayAddEditTag(tagId, startSeconds)
    {
        if (!tagId || !startSeconds) {
            this.alert("Tag ID is invalid for editing the tag.");
            return false;
        }

        let $tag = $('#VideoTag' + tagId);
        let $tags = $('#tags');

        this.gotoVideoTime(startSeconds, false);

        $('#tagId').val(tagId);
        $tags.val($tag.text().replaceAll(' ', ''));
        $('#start_seconds').val(startSeconds);
        $('.divAddVideoTagForm').show();
        $('.btn-video-addTag').hide();
        $tags.focus();

        return true;
    }

    hideAddForm()
    {
        $('.divAddVideoTagForm').hide();
        $('.btn-video-addTag').show();
    }

    /**
     * Sets up our events like clicking on a tag and submitting forms.
     *
     * @private
     */
    addListeners()
    {

        $('#frmAddVideoTag').submit((event) => {
            event.preventDefault();
            this.submitAddForm();
        });

        $('.divAddVideoTagForm .btnClose').click((event) => {
            event.preventDefault();
            this.hideAddForm();
        });

        $('.btn-video-addTag').click((event) => {
            event.preventDefault();
            this.showAddForm();
        });

        $('.atc-btnVideoTag').on('click', (event) => {
            this.onVideoTagClick(event);
        });

        $('.report-video').on('click', (event) => {
            this.onReportVideoClick(event);
        });

    }

    /**
     * Add click event listeners for the admin actions.
     */
    addAdminListeners()
    {
        // If one of the options in the admin popup was clicked.
        $('.atc-tagAdminActions a').click((event) => {
            this.processAdminActionsEvent(event);
        });

        // If the admin options button was clicked.
        $('.admin-options').on('click', (event) => {
            this.onAdminOptionsClick(event);
        });
    }

    /**
     * Handles the click event for reporting a video tag. This method prevents the default and propagation of the event, retrieves
     * the video and tag information, and displays a modal to collect a reason for reporting the tag. Once the reason is provided,
     * it sends the report data to the server and handles the response by displaying success or error messages accordingly.
     *
     * @param {Event} event - The event object associated with the click action that triggered the report process.
     * @return {void} This method does not return a value.
     */
    onReportVideoClick(event)
    {
        event.preventDefault();
        event.stopPropagation();

        const videoId = parseInt($('#videoId').val());
        const tagId = parseInt($(event.currentTarget).attr('data-id'));
        const tag = $(event.currentTarget).attr('data-tag');

        atcError.displayModalWithInput("Report Tag", "Please enter a reason for reporting this tag. Example: It's the wrong tag or the tag is not at the right time.", (reason) => {
            fetch(`/videos/${videoId}/report`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                body: new URLSearchParams({
                    videoId: videoId,
                    tagId: tagId,
                    tag: tag,
                    reason: reason
                })
            }).then(response => response.json()).then(data => {
                console.log('report submitted', data);
                if (data.success) {
                    atcError.displayMessage("Your report has been submitted. Thank you.", "Video Tag Reported");
                } else {
                    atcError.displayError(data.message || "Unable to report video tag. Please email support.");
                }
            }).catch((err) => {
                console.error(err);
                atcError.displayError("Unable to report video tag. Please email support.");
            });

        });
    }

    onAdminOptionsClick(event)
    {
        event.preventDefault();
        event.stopPropagation();

        if (!this.isModeratorUser()) {
            alert("You are not authorized to Use these features.");
            return;
        }

        const isVisible = function (elem) {
            return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
        };

        // let adminActions = event.currentTarget.nextElementSibling;
        let adminActions = document.evaluate("following-sibling::div", event.currentTarget, null,
            XPathResult.FIRST_ORDERED_NODE_TYPE).singleNodeValue;

        // event.preventDefault();
        Array.from(document.getElementsByClassName('atc-tagAdminActions')).forEach((item) => {
            if (item !== adminActions) {
                item.style.display = 'none';
            }
        });

        adminActions.style.display = isVisible(adminActions) ? 'none' : 'block';
    }

    /**
     * When the video tag is clicked, we want to show an admin form.
     *
     * @param event
     */
    onVideoTagClick(event)
    {
        this.gotoVideoTime(parseInt(event.currentTarget.getAttribute('data-start-seconds')));
    }

    /**
     * Abstract it out for the old and new trading rooms
     *
     * @returns {Boolean}
     */
    isModeratorUser()
    {
        return this.isAdmin;
        // return typeof atcOptions !== 'undefined' ? atcOptions.self().isModeratorUser() : false;
    }

    /**
     * Delete a tag
     *
     * @param {Number|*} tagId
     * @return {boolean}
     */
    removeTag(tagId)
    {
        if (!this.isModeratorUser()) {
            return false;
        }

        if (typeof tagId !== 'number') {
            tagId = parseInt(tagId);
        }

        const data = {
            _method: 'DELETE',
            videoId: parseInt($('#videoId').val()),
            videoTagId: tagId
        };

        $.ajax({
            type: 'POST',
            url: "/videos/time-tags/" + tagId,
            data: data
        }).fail((err) => {
            console.warn(err);
            this.alert("Video Tag Failed. Please try again later or contact support.");
        });
    }

    /**
     *
     * @param {Object} tag
     * @returns {jQuery}
     */
    formatTagLine(tag)
    {
        tag['start_min'] = ("0" + Math.floor(tag['start_seconds'] / 60)).slice((tag['start_seconds'] / 60) > 99 ? -3 : -2);
        tag['start_sec'] = ("0" + Math.floor(tag['start_seconds'] % 60)).slice(-2);

        let $tagActions = $('#VideoTagExample').clone();
        $tagActions.attr('data-id', tag['id']).removeClass('d-none').attr('id', 'VideoTagId' + tag['id']);

        // format the link
        $('a.atc-btnVideoTag', $tagActions)
            .attr('data-video-id', tag['videoId'])
            .attr('data-start-seconds', tag['start_seconds'])
            .attr('href', '#T-' + encodeURIComponent(tag['tags']) + '-' + tag['start_seconds'])
            .attr('id', 'VideoTag' + tag['id'])
            .text(tag['tags']).click((event) => {
            this.onVideoTagClick(event);
        });

        // Format the Time
        $('time', $tagActions).text('(' + tag['start_min'] + ':' + tag['start_sec'] + ')');

        // Format the report button
        $('.report-video', $tagActions).attr('data-id', tag['id']).attr('data-tag', tag['tags']).attr('data-video-id', tag['videoId']).on('click', (event) => {
            this.onReportVideoClick(event);
        });

        if (this.isModeratorUser()) {
            // format the admin actions
            $('.atc-tagAdminActions', $tagActions).attr('data-start-seconds', tag['start_seconds']).attr('data-id', tag['id']).find('a').on('click', (event) => {
                this.processAdminActionsEvent(event);
            });
        } else {
            // Not a moderator, so hide the admin actions
            $('.atc-tagAdminActions', $tagActions).remove();
        }

        return $tagActions;
    }

    /**
     * Clicking on any one of the admin events (delete, edit, play)
     *
     * @param {Event} event
     */
    processAdminActionsEvent(event)
    {
        event.preventDefault();
        event.stopPropagation();

        /** @var {Array} classList */
        const classList = Array.from(event.currentTarget.firstChild.classList);

        /** @var {HTMLElement} parentElement */
        const parentElement = event.currentTarget.parentElement;
        const tagId = parseInt(parentElement.getAttribute('data-id'));
        const startSeconds = parseInt(parentElement.getAttribute('data-start-seconds'));

        if (classList.indexOf('fa-edit') !== -1) {
            this.editTag(tagId, startSeconds);
        } else if (classList.indexOf("fa-trash-o") !== -1) {
            this.removeTag(tagId);
            $('.public-videoTag[data-id="' + tagId + '"]').remove();
        }

        $('.atc-tagAdminActions').hide();
    }

    /**
     * Forward the video to the start seconds position.
     *
     * @param {Number} startSeconds
     * @param {boolean=} startPlayback
     */
    gotoVideoTime(startSeconds, startPlayback)
    {
        let myVideo = document.getElementById('VideoCaller');
        if (typeof startPlayback !== 'boolean') {
            startPlayback = true;
        }

        if (myVideo) {
            myVideo.currentTime = startSeconds;
            if (startPlayback) {
                myVideo.play().catch(function (exception) {
                    // This throws when we initially load the dom with a "play() failed due to the user not interacting with the DOM first."
                    console.warn(exception);
                });
            }

        } else {
            console.warn("Unable to find your element by ID #VideoCaller");
        }
    }

    /*
    loadVideoTags($target)
    {
        const url = "/videos/time-tags/" + parseInt($('#videoId').val());
        $.getJSON(url, (data) => {
            let $htm = $('<div class="atc-videoTags"/>');
            data['tags'].forEach((tag) => {
                $htm.append(this.formatTagLine(tag));
            });

            $($target).find('div').remove();
            $($target).append($htm);
        });
    }
     */

    /**
     * Gets the number of seconds for the video start time based on the URI hash.
     *
     * @param {String|undefined} hash
     * @returns {number}
     */
    static getHashTime(hash)
    {
        if (!hash || typeof hash !== 'string' || hash.length < 3) {
            return 0;
        }

        const hashBits = hash.split('-');
        return hashBits.length === 3 ? parseInt(hashBits[2]) : 0;
    }

    /**
     *
     * @returns {boolean}
     */
    submitAddForm()
    {
        const tags = $('#tags').val();
        const tagId = parseInt($('#tagId').val());

        if (typeof tags !== 'string' || !tags.length) {
            alert('Please enter a tag or list of tags separated by commas.');
            return false;
        }

        if (!tags.match(/^[a-zA-Z0-9.,]+$/)) {
            alert("Please use alpha numeric characters only.");
            return false;
        }

        const data = {
            videoId: parseInt($('#videoId').val()),
            tagId: tagId,
            tags: tags,
            start_seconds: parseInt($('#start_seconds').val()),
            end_seconds: parseInt($('#end_seconds').val())
        };

        const ajaxSuccess = (data) => {
            if (!data.success) {
                alert(data.message);
            } else {
                const videoTag = data.videoTag;
                let $existingTag = $('.atc-videoTag[data-id="' + videoTag['id'] + '"]');
                const $newTag = this.formatTagLine(videoTag);

                if ($existingTag.length > 0) {
                    $existingTag.replaceWith($newTag);//edit entry
                } else {
                    $('#VideoTagListings').append($newTag);//new addition
                }

            }
        };

        $.ajax({
            type: 'POST',
            url: "/videos/time-tags/" + data.videoId,
            data: data,
            success: ajaxSuccess
        }).fail((err) => {
            if (window.console) {
                console.error("Video Tag Failed: ");
                console.error(err);
            }

            this.alert("Video Tag Failed. Please try again later or contact support.");
        });

        $('.divAddVideoTagForm').hide();
        $('.btn-video-addTag').show();

        return true;
    }

}

// Load this module when the DOM is ready
window.addEventListener('load', function() {
    (new VideoTagManager(VideoTagManager.getVideoIdFromDOM()));
});
